import './AthleteAddFailureToast.css';

import React, {
  useCallback,
} from 'react';
import { createPortal } from 'react-dom';

export interface AthleteAddFailureToastProps {
  /** When false, exit animation runs; keep `message` until `onExitComplete`. */
  open: boolean;
  message: string;
  onDismiss: () => void;
  onExitComplete: () => void;
}

const AthleteAddFailureToast: React.FC<AthleteAddFailureToastProps> = ({
  open,
  message,
  onDismiss,
  onExitComplete,
}) => {
  const handleSurfaceAnimationEnd = useCallback(
    (e: React.AnimationEvent<HTMLDivElement>): void => {
      if (e.target !== e.currentTarget) return;
      if (e.animationName === 'athlete-add-failure-toast-out') {
        onExitComplete();
      }
    },
    [onExitComplete],
  );

  if (!message.trim()) {
    return null;
  }

  return createPortal(
    <div
      className="athlete-add-failure-toast-root"
      role="alert"
      aria-live="assertive"
      aria-atomic="true"
      aria-hidden={!open}
    >
      <div
        className={[
          'athlete-add-failure-toast-surface',
          open ? '' : 'athlete-add-failure-toast-surface--exit',
        ]
          .filter(Boolean)
          .join(' ')}
        onAnimationEnd={handleSurfaceAnimationEnd}
      >
        <button
          type="button"
          className="athlete-add-failure-toast-close"
          onClick={onDismiss}
          aria-label="Close notification"
          disabled={!open}
        >
          ×
        </button>
        <div className="athlete-add-failure-toast-icon-wrap" aria-hidden="true">
          <span className="athlete-add-failure-toast-icon">!</span>
        </div>
        <div className="athlete-add-failure-toast-main">
          <p className="athlete-add-failure-toast-headline">Could not add athlete</p>
          <p className="athlete-add-failure-toast-message">{message.trim()}</p>
        </div>
      </div>
    </div>,
    document.body,
  );
};

export default AthleteAddFailureToast;
